import * as React from "react";

export interface BookmarkablePageContextValue {
  withBreadcrumbs: boolean;
}

export const BookmarkablePageContext = React.createContext<BookmarkablePageContextValue>({ withBreadcrumbs: false });
